import React from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { useScreenSize } from '@/hooks';
import MenuContent from './MenuContent';
import styles from './Sidebar.module.css';

/**
 * Sidebar Component – CRYPTMET theme
 * Navigation sidebar: Surface #121826, Divider #222B3A, Gold for active
 * Hidden on mobile (bottom nav used instead)
 */
const Sidebar = ({ isCollapsed, onToggle, onItemClick }) => {
  const { isMobile, isTablet } = useScreenSize();
  const location = useLocation();

  if (isMobile || isTablet) {
    return null; // Sidebar hidden on mobile & tablet, use bottom nav instead
  }

  // Handler to close sidebar when item is clicked
  const handleItemClick = () => {
    if (onItemClick) {
      onItemClick();
    }
  };

  return (
    <aside 
      className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ''}`}
    >
      <div className={styles.sidebarContent}>
        <MenuContent isCollapsed={isCollapsed} onItemClick={handleItemClick} />
      </div>
    </aside>
  );
};

export default Sidebar;
